import React from 'react';
import SettingsApolloProvider from '../PluginInstallationGuide/clients/SettingsApolloProvider';
import { AccessProvider } from '../PluginInstallationGuide/hooks/useAccess';
import { ActiveBoostProductsProvider } from '../PluginInstallationGuide/hooks/useActiveBoostProducts';
import { ApiKeyProvider } from '../PluginInstallationGuide/hooks/useApiKey';
import { ClientIdProvider } from '../PluginInstallationGuide/hooks/useClientId';
import { ErrorProvider } from '../PluginInstallationGuide/hooks/useError';
import { MidProvider } from '../PluginInstallationGuide/hooks/useMid';
import { PluginProvider } from '../PluginInstallationGuide/hooks/usePlugin';
import Page from './components/Page';
import { CollapsibleStepsProvider } from './hooks/useCollapsibleSteps';
export default function BoostPluginPage() {
    return (React.createElement(ErrorProvider, null,
        React.createElement(PluginProvider, { mustExtractPluginIdFromUrl: false },
            React.createElement(MidProvider, null,
                React.createElement(SettingsApolloProvider, null,
                    React.createElement(AccessProvider, null,
                        React.createElement(ApiKeyProvider, null,
                            React.createElement(ClientIdProvider, null,
                                React.createElement(ActiveBoostProductsProvider, null,
                                    React.createElement(CollapsibleStepsProvider, null,
                                        React.createElement(Page, null)))))))))));
}
